const ITEMS = [
  "Aluminium Fabrication", "Composite Cladding", "Office Partitions",
  "Structural Glazing", "Shopfronts", "Curtain Walls", "Windows & Doors",
  "Tempered Glass", "All Ceiling Types", "Iron Works", "Pantry Cupboards", "Roller Doors",
];

export default function Marquee() {
  const doubled = [...ITEMS, ...ITEMS];
  return (
    <div style={{ borderTop: "1px solid var(--ink)", borderBottom: "1px solid var(--ink)", overflow: "hidden", background: "#fff" }}>
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span key={i} className="marquee-item">{item}</span>
        ))}
      </div>
    </div>
  );
}
